import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import translationPTBR from './locales/pt-BR/translation.json'
import translationESPY from './locales/es/translation.json'
import translationPTPT from './locales/pt-PT/translation.json'
import { getParamsFromQueryString } from './utils/url'

const { app_id: appId } = getParamsFromQueryString()

export const languages = [ 'pt-BR', 'es', 'pt-PT' ]
// the translations
// (tip move them in a JSON file and import them)
const resources = {
  'pt-BR': {
    translation: translationPTBR
  },
  'es': {
    translation: translationESPY
  },
  'pt-PT': {
    translation: translationPTPT
  }
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: appId !== '33' ? 'pt-BR' : 'pt-PT',

    keySeparator: false, // we do not use keys in form messages.welcome
    returnObjects: true,
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  })

export default i18n
